import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_PASSWORD_POLICY);
var axios_instance_2 = get_axios_instance(api_variables.SERVICE_GET_PASSWORD_POLICY);

const state = {
    data: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },
}

const actions = {

    async fetchPolicy({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance_2.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", res.data);
            }

            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
   
    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEmployee", payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.emp_id}`, payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("updateEmployeeById", res.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    
}

export default {
    namespaced: true,
    state, mutations, actions
}